import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AddAddressParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";
import { getCase } from "./get-case";

/**
 * Registers a new address for the customer and reloads the case (DMS-28), so
 * the "otras direcciones" list and the trail entry the backend appended both
 * come from the server.
 */
export const addAddress = createAsyncThunk<
  void,
  AddAddressParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.ADD_ADDRESS, async (params, { dispatch, extra }) => {
  await extra.complianceRepo.addAddress(params);
  await dispatch(getCase({ requestId: params.requestId }));
});
